import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { StaffOrganizationReferenceService } from "lib-klab-sdks";
import { OrganizationReferencePort } from "../../../app/ports/organization/organization-reference.port";
import {
  OrganizationBranch,
  OrganizationCompany,
  OrganizationCostCenter,
  OrganizationDepartment,
  OrganizationPosition,
} from "../../../domain/models/organization/organization-reference.model";
import {
  mapOrganizationBranch,
  mapOrganizationCompany,
  mapOrganizationCostCenter,
  mapOrganizationDepartment,
  mapOrganizationPosition,
} from "../../mappers/organization/organization-reference.mapper";

@Injectable({ providedIn: "root" })
export class OrganizationReferencePortAdapter implements OrganizationReferencePort {
  constructor(private readonly api: StaffOrganizationReferenceService) {}

  listCompanies(): Observable<OrganizationCompany[]> {
    return this.api
      .listCompanies()
      .pipe(map((items) => items.map(mapOrganizationCompany)));
  }

  listBranches(companyId?: number): Observable<OrganizationBranch[]> {
    return this.api
      .listBranches(companyId)
      .pipe(map((items) => items.map(mapOrganizationBranch)));
  }

  listDepartments(): Observable<OrganizationDepartment[]> {
    return this.api
      .listDepartments()
      .pipe(map((items) => items.map(mapOrganizationDepartment)));
  }

  listPositions(departmentId?: number): Observable<OrganizationPosition[]> {
    return this.api
      .listPositions(departmentId)
      .pipe(map((items) => items.map(mapOrganizationPosition)));
  }

  listCostCenters(companyId?: number): Observable<OrganizationCostCenter[]> {
    return this.api
      .listCostCenters(companyId)
      .pipe(map((items) => items.map(mapOrganizationCostCenter)));
  }
}
